<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="820" persistent>
      <v-card class="np-card">
        <v-card-title class="np-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-briefcase-account</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Convertir a prospecto</div>
              <div class="text-body-2 white--text">
                Vincula la persona, sede y programa para continuar
              </div>
            </div> 
          </div>
        </v-card-title> 

        <v-card-text class="pt-4 pb-14 mb-14"> 
          <timelineProgreso ref="reftimelineProgreso"/>
          <v-divider class="mt-0" />

          <p class="mb-3">
            <b>Nombre del contacto: </b> {{ contacto.nombres }} {{ contacto.apellidos }}
          </p>

          <!-- Paso 1: Buscar por documento -->
          <v-row dense class="mb-2">
            <v-col cols="12" sm="7">
              <v-text-field
                v-model="carnetBusqueda"
                label="* Número de documento exacto:"
                outlined
                dense
                hide-details
                prepend-inner-icon="mdi-card-account-details"
                placeholder="Ingrese el número de documento..."
                @keyup.enter="buscarPersona"
              />
            </v-col>
            <v-col cols="12" sm="5">
              <v-btn
                color="blue darken-2"
                class="white--text"
                :loading="isloadingestudent"
                :disabled="!carnetBusqueda || isloadingestudent"
                height="40"
                block
                @click="buscarPersona"
              >
                <v-icon left small>mdi-magnify</v-icon>
                Buscar persona en Portal
              </v-btn>
            </v-col>
          </v-row>

          <!-- Paso 2: Formulario persona -->
          <v-expand-transition>
            <div v-if="searchDone" class="persona-section">
              <v-alert v-if="mensajeSimilitudBaja" type="error" dense text class="mb-2 np-alert">
                <div><b>Los nombres son demasiado diferentes, no es posible continuar con el registro.</b></div>
                <div class="mt-1"><b>Nombre del contacto:</b> {{ mensajeSimilitudBaja.contacto }}</div>
                <div><b>Nombre en el sistema:</b> {{ mensajeSimilitudBaja.encontrado }}</div>
                <div class="caption mt-1">Similitud: {{ mensajeSimilitudBaja.similitud }}% &mdash; se requiere al menos {{min_similitud}}%</div>
              </v-alert>
              <template v-else>
              <v-alert v-if="personaEncontrada" dense text type="success" class="mb-2 np-alert">
                Persona encontrada en el sistema, similitud en nombres: {{ similitud_nombres }}%
                <!-- <p> persona_verificada: {{ persona_verificada }} </p> -->
              </v-alert>
              <v-alert v-else dense text type="error" class="mb-2 np-alert">
                No se encontró coincidencia exacta. Complete los campos para registrar a la persona.
              </v-alert>

              <div class="persona-form" :class="{ 'persona-form--editable': personaEncontrada && !persona_verificada }">
              <v-row dense>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="new_persona_data.num_doc"
                    label="* Nro documento"
                    outlined
                    dense
                    :readonly="!!personaEncontrada"
                    prepend-inner-icon="mdi-card-account-details"
                  />
                </v-col> 
                <v-col cols="12" sm="8">
                  <v-autocomplete
                    v-model="new_persona_data.profesiones"
                    :items="profesiones"
                    item-text="nombre"
                    item-value="id"
                    label="* Profesión"
                    outlined
                    dense
                    prepend-inner-icon="mdi-briefcase"
                    :loading="isLoadingProfesiones"
                    :readonly="personaEncontrada && persona_verificada"
                    :clearable="!personaEncontrada || !persona_verificada"
                    hide-no-data
                    placeholder="Escribe para buscar..."
                  />
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="new_persona_data.nombres"
                    label="* Nombres"
                    outlined
                    dense
                    :readonly="similitud_nombres > 75 || (personaEncontrada && persona_verificada)"
                    prepend-inner-icon="mdi-account"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="new_persona_data.pri_apellido"
                    label="* Primer apellido"
                    outlined
                    dense
                    :readonly="similitud_nombres > 75 || (personaEncontrada && persona_verificada)"
                    prepend-inner-icon="mdi-account"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="new_persona_data.seg_apellido"
                    label="Segundo apellido"
                    outlined
                    dense
                    :readonly="similitud_nombres > 75 || (personaEncontrada && persona_verificada)"
                    prepend-inner-icon="mdi-account"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="new_persona_data.email"
                      label="* Correo"
                      outlined
                      dense
                      :readonly="personaEncontrada && persona_verificada"
                      prepend-inner-icon="mdi-email"
                    />
                  </v-col>
                <v-col cols="12" sm="3">
                    <v-text-field
                      v-model="new_persona_data.telefono1"
                      label="* Teléfono"
                      outlined
                      dense
                      :readonly="personaEncontrada && persona_verificada"
                      prepend-inner-icon="mdi-phone"
                    />
                  </v-col>
                  <v-col cols="12" sm="3">
                    <div class="sexo-field-wrap">
                      <span class="sexo-field-label">* Sexo</span>
                      <v-btn-toggle v-model="new_persona_data.sexo" dense class="sexo-toggle">
                        <v-btn value="M" small :color="new_persona_data.sexo === 'M' ? 'blue darken-1' : ''" :class="new_persona_data.sexo === 'M' ? 'white--text' : ''" :disabled="personaEncontrada && persona_verificada">
                          <v-icon small left>mdi-gender-male</v-icon> M
                        </v-btn>
                        <v-btn value="F" small :color="new_persona_data.sexo === 'F' ? 'pink darken-1' : ''" :class="new_persona_data.sexo === 'F' ? 'white--text' : ''" :disabled="personaEncontrada && persona_verificada">
                          <v-icon small left>mdi-gender-female</v-icon> F
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete
                      v-model="new_persona_data.idciudad"
                      :items="ciudades"
                      item-text="nombre"
                      item-value="id"
                      label="* Ciudad de residencia"
                      outlined
                      dense
                      prepend-inner-icon="mdi-city"
                      :loading="isLoadingCiudades"
                      :readonly="personaEncontrada && persona_verificada"
                      :clearable="!personaEncontrada || !persona_verificada"
                      hide-no-data
                      hide-selected
                      placeholder="Escribe para buscar..."
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-autocomplete
                      v-model="new_persona_data.idpais"
                      :items="nacionalidades"
                      item-text="nombre"
                      item-value="id"
                      label="* Nacionalidad"
                      outlined
                      dense
                      prepend-inner-icon="mdi-flag"
                      :loading="isLoadingNacionalidades"
                      :readonly="personaEncontrada && persona_verificada"
                      :clearable="!personaEncontrada || !persona_verificada"
                      hide-no-data
                      hide-selected
                      placeholder="Escribe para buscar..."
                    />
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="new_persona_data.fecha_nac"
                      label="* Fecha de nacimiento"
                      outlined
                      dense
                      type="date"
                      prepend-inner-icon="mdi-calendar-account"
                      :readonly="!!personaEncontrada"
                    />
                  </v-col>
                <v-col cols="12" sm="4">
                  <v-autocomplete
                    v-model="new_persona_data.grados"
                    :items="grados"
                    item-text="nombre"
                    item-value="id"
                    label="* Grado academico"
                    outlined
                    dense
                    prepend-inner-icon="mdi-briefcase"
                    :loading="isLoadinggrados"
                    :readonly="personaEncontrada && persona_verificada"
                    :clearable="!personaEncontrada || !persona_verificada"
                    hide-no-data
                    placeholder="Escribe para buscar..."
                  />
                </v-col>

                <v-col cols="12" sm="4">
                    <v-autocomplete
                      v-model="new_persona_data.idinstitucion"
                      :items="instituciones"
                      item-text="nombre"
                      item-value="id"
                      label="* Institucion de egreso"
                      outlined
                      dense
                      prepend-inner-icon="mdi-city"
                      :loading="isLoadinginstituciones"
                      :readonly="personaEncontrada && persona_verificada"
                      :clearable="!personaEncontrada || !persona_verificada"
                      hide-no-data
                      hide-selected
                      placeholder="Escribe para buscar..."
                    />
                  </v-col>

                <!-- Persona encontrada pero no verificada: forzar edición y subir documento -->
                <template v-if="personaEncontrada && !persona_verificada">
                  <v-col cols="12">
                    <v-alert dense text type="red" class="mb-2 np-alert">
                      Esta persona no está verificada. Completa y actualiza sus datos antes de continuar. El documento de identidad es obligatorio.
                    </v-alert>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-file-input 
                      v-model="documentoIdentidad"
                      label="* Documento de identidad (obligatorio)"
                      outlined
                      dense
                      accept="image/*,application/pdf"
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-upload"
                      clearable
                      @change="onDocumentoChange"
                    />
                  </v-col>
                  <v-col v-if="documentoPreview" cols="12">
                    <div class="doc-preview-wrap">
                      <img v-if="documentoEsImagen" :src="documentoPreview" class="doc-preview-img" alt="Vista previa" />
                      <iframe v-else :src="documentoPreview" class="doc-preview-pdf" title="Vista previa" />
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="orange darken-2"
                      class="white--text"
                      small
                      :loading="isUpdatingPersona"
                      :disabled="isUpdatingPersona"
                      @click="actualizarPersona"
                    >
                      <v-icon left small>mdi-content-save</v-icon>
                      Actualizar persona
                    </v-btn>
                  </v-col> 
                </template>

                <v-col v-if="persona_verificada" cols="12">
                  <v-chip small color="teal lighten-5" text-color="teal darken-2" class="font-weight-medium">
                    <v-icon small left color="teal darken-2">mdi-check-decagram</v-icon>
                    Persona verificada
                  </v-chip>
                </v-col>

                <!-- Subir documento si coincidencia exacta pero nombres difieren -->
                <template v-if="personaEncontrada && persona_verificada && mostrarSubirDocumento">
                  <v-col cols="12">
                    <v-alert dense text type="info" class="mb-2 np-alert">
                      <v-icon small left>mdi-information</v-icon>
                      Los nombres del contacto difieren de los registrados. Se recomienda subir el documento de identidad.
                    </v-alert>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-file-input
                      v-model="documentoIdentidad"
                      label="Subir Documento de identidad"
                      outlined
                      dense
                      accept="image/*,application/pdf"
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-upload"
                      clearable
                      @change="onDocumentoChange"
                    />
                  </v-col>
                  <v-col v-if="documentoPreview" cols="12">
                    <div class="doc-preview-wrap">
                      <img v-if="documentoEsImagen" :src="documentoPreview" class="doc-preview-img" alt="Vista previa" />
                      <iframe v-else :src="documentoPreview" class="doc-preview-pdf" title="Vista previa" />
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="blue darken-2"
                      class="white--text"
                      small
                      :disabled="!documentoIdentidad"
                      :loading="uploading_doc"
                      @click="subirDocumentoIdentidad(new_prospecto.persona_id)"
                    >
                      <v-icon left small>mdi-cloud-upload</v-icon>
                      Subir documento
                    </v-btn>
                  </v-col>
                </template>

                <!-- Campos adicionales solo si no hay coincidencia exacta -->
                <template v-if="!personaEncontrada">
                  <v-col cols="12" sm="6">
                    <v-file-input
                      v-model="documentoIdentidad"
                      label="Subir Documento de identidad"
                      filled
                      outlined
                      dense
                      accept="image/*,application/pdf"
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-upload"
                      clearable
                      @change="onDocumentoChange"
                    />
                  </v-col>
                  <v-col v-if="documentoPreview" cols="12">
                    <div class="doc-preview-wrap">
                      <img
                        v-if="documentoEsImagen"
                        :src="documentoPreview"
                        class="doc-preview-img"
                        alt="Vista previa del documento"
                      />
                      <iframe
                        v-else
                        :src="documentoPreview"
                        class="doc-preview-pdf"
                        title="Vista previa del documento"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <v-btn
                      color="blue darken-2"
                      class="white--text"
                      small
                      :loading="isCreatingPersona"
                      :disabled="isCreatingPersona"
                      @click="crearNuevaPersona"
                    >
                      <v-icon left small>mdi-account-plus</v-icon>
                      Registrar persona
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
              </div>
              </template>
            </div>
          </v-expand-transition>

          <!-- Paso 3: Selección de sede, gestión y programa -->
          <v-expand-transition>
            <div v-if="new_prospecto.persona_id" class="mt-4">
              <v-divider class="mb-4" />
              <v-btn color="blue" outlined class="black--text mb-3" small v-if="personaEncontrada" :loading="isUpdatingPersona" :disabled="isUpdatingPersona" @click="opencursados()">
                <v-icon left small>mdi-eye</v-icon>
                ver programas cursados
              </v-btn>

              <p class="mb-1"><b>Selecciona el programa al que desea inscribirse:</b></p>
              <v-row dense>
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model.number="gestion"
                    label="Gestión"
                    type="number"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-calendar"
                  />
                </v-col>
                <v-col cols="12" sm="9">
                  <v-autocomplete
                    v-model="sede"
                    :items="sedes"
                    item-text="nombre"
                    item-value="id"
                    label="Sede"
                    outlined
                    dense
                    hide-details
                    prepend-inner-icon="mdi-office-building-marker"
                    placeholder="Seleccione la sede..."
                    return-object
                    clearable
                  />
                </v-col>
                <v-col cols="12">
                  <v-combobox
                    v-model="filtroprograma"
                    :items="programas"
                    label="Programa en comercializacion:"
                    :loading="isloadingprograma"
                    placeholder="Seleccione un programa..."
                    outlined
                    dense
                    prepend-inner-icon="mdi-school"
                  />
                </v-col>
              </v-row>
            </div>
          </v-expand-transition>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
          <v-btn
            v-if="new_prospecto.persona_id"
            color="green"
            class="white--text"
            :loading="loading"
            @click="enviar()"
          >
            <v-icon left small>mdi-check</v-icon>
            Convertir a prospecto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="false">
      <ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" />
    </div>
    <verCursados ref="refverCursados"/>
  </div>
</template>

<script>
  import ABuscarPersona from '@/components/ABuscarPersona';
  import { getSedes, listarprogramasgraphql2, subirDocumentoContacto } from './utils';
  import gql from 'graphql-tag';
  import verCursados from './ver-cursados.vue';
  import timelineProgreso from './timeline-progreso.vue';
import { realizar_preinscripcion_from_prospecto } from './inscripcion/utils';
import { nameSimilarity } from './similarity';

  export default {
    components: {
      ABuscarPersona,
      verCursados,
      timelineProgreso,
    },
    data() {
      return {
        loading: true,
        gestion: new Date().getFullYear(),
        isloadingprograma: false,
        isloadingestudent: false,
        dialog: false,
        contacto: {},
        carnetBusqueda: '',
        searchDone: false,
        personaEncontrada: null,
        estudiantes: [],
        filtroprograma: '',
        estado: 'PROSPECTO',
        sedes: [],
        sede: null,
        programas: [],
        new_prospecto: {},
        new_persona_data: {
          num_doc: '',
          nombres: '',
          pri_apellido: '',
          seg_apellido: '',
          email: '',
          sexo: '',
          tipo: 'P',
          diestro: true,
          telefono1: '',
          profesiones: null,
          grados: null,
          idciudad: null,
          idpais: null,
          fecha_nac: '',
        },
        isCreatingPersona: false,
        profesiones: [],
        grados: [],
        instituciones: [],
        isLoadingProfesiones: false,
        isLoadinggrados: false,
        isLoadinginstituciones: false,
        ciudades: [],
        isLoadingCiudades: false,
        nacionalidades: [],
        isLoadingNacionalidades: false,
        documentoIdentidad: null,
        documentoPreview: null,
        documentoEsImagen: false,
        mostrarSubirDocumento: false,
        mensajeSimilitudBaja: null,
        uploading_doc: false,
        similitud_nombres: '',
        persona_verificada: false,
        min_similitud: 75.0,
        doc_64: '',
        isUpdatingPersona: false,
      };
    },
    watch: {
      filtroprograma: async function (a) {
        if (typeof a == 'object') {
          this.isloadingprograma = false;
          this.setDatosPrograma();
        }
      },
      sede: async function (a) {
        if (a) {
          this.filtroprograma = null;
          this.isloadingprograma = true;
          this.programas = await listarprogramasgraphql2(this, this.sede.id, this.gestion);
          this.isloadingprograma = false;
        }
      },
      gestion: async function (val) {
        if (val && val.toString().length === 4 && this.sede) {
          this.filtroprograma = null;
          this.isloadingprograma = true;
          this.programas = await listarprogramasgraphql2(this, this.sede.id, val);
          this.isloadingprograma = false;
        }
      },
    },
    methods: {
      async openmodal(row) {
        this.filtroprograma = '';
        this.carnetBusqueda = '';
        this.searchDone = false;
        this.isloadingestudent = false;
        this.personaEncontrada = null;
        this.estudiantes = [];
        this.contacto = row;
        this.loading = false;
        this.dialog = true;
        this.new_prospecto = {};
        this.resetNewPersonaData();
        this.new_prospecto.contacto_id = row.id;
        this.new_prospecto.persona_name = row.nombres + ' ' + row.apellidos;
        this.new_prospecto.estado = this.estado;
        this.new_prospecto.fecha_conversion = new Date().toISOString();
        this.documentoIdentidad = null;
        this.documentoPreview = null;
        this.documentoEsImagen = false;
        this.doc_64 = ''

        this.$nextTick(() => {
          this.$refs.reftimelineProgreso.iniciar(1, false); 
        }); 

        this.sedes = await getSedes(this);
        this.sede = this.sedes.find((x) => x.id == this.$store.state.CARGO.sede.id);

        this.isloadingprograma = true;
        this.programas = await listarprogramasgraphql2(this, this.sede.id, this.gestion);
        this.isloadingprograma = false;

        this.loadProfesiones();
        this.loadGrados();
        this.loadCiudades();
        this.loadNacionalidades();
        this.loadInstituciones()
      },
      cerrar() {
        this.dialog = false;
      },
      getTelNormalizado(t){
        if(!t) return t;
        return t.replaceAll('+','')
      },
      async buscarPersona() {
        if (!this.carnetBusqueda) return;
        this.searchDone = false;
        this.personaEncontrada = null;
        this.mostrarSubirDocumento = false;
        this.mensajeSimilitudBaja = null;
        this.estudiantes = [];
        this.isloadingestudent = true;
        this.new_prospecto.persona_id = null;
        this.new_prospecto.persona_name = null;
        const r = await this.$refs.abuscarpersona.asyncfindpersona(this.carnetBusqueda, this);
        this.isloadingestudent = false;
        this.estudiantes = r;
        this.resultadobusquedaest()
      },
      async resultadobusquedaest() {
        this.similitud_nombres = 0;
        this.isloadingestudent = false;
        this.resetNewPersonaData();
        this.searchDone = true;

        const exactMatch = this.estudiantes.find((e) => e.num_doc === this.carnetBusqueda);
        await this.loadProfesiones();
        await this.loadGrados();
        await this.loadCiudades();
        await this.loadNacionalidades();
        await this.loadInstituciones();

        if (exactMatch) {
          this.personaEncontrada = exactMatch;
          const nombreContacto = `${this.contacto.nombres || ''} ${this.contacto.apellidos || ''}`.toLowerCase().trim();
          const nombreExacto = `${exactMatch.nombres} ${exactMatch.pri_apellido} ${exactMatch.seg_apellido || ''}`.toLowerCase().trim();
          // const similitud = this.jaroWinkler(nombreContacto, nombreExacto);
          const similitud = nameSimilarity(nombreContacto, nombreExacto)
          window.console.log('similitud', similitud);
          
          this.similitud_nombres = Math.round(similitud * 100);
          this.persona_verificada = exactMatch.is_verificado? true: false
          

          if (Math.round(similitud * 100) < this.min_similitud) {
            this.personaEncontrada = null;
            this.mensajeSimilitudBaja = {
              contacto: nombreContacto,
              encontrado: nombreExacto,
              similitud: Math.round(similitud * 100),
            };
            return;
          }

          this.mensajeSimilitudBaja = null;
          this.mostrarSubirDocumento = false;

          this.new_persona_data.num_doc = exactMatch.num_doc;
          this.new_persona_data.nombres = exactMatch.nombres;
          this.new_persona_data.pri_apellido = exactMatch.pri_apellido;
          this.new_persona_data.seg_apellido = exactMatch.seg_apellido || '';
          this.new_persona_data.email = exactMatch.email || '';
          this.new_persona_data.telefono1 = this.getTelNormalizado(exactMatch.telefono1);

          const name = `${exactMatch.nombres} ${exactMatch.pri_apellido} ${exactMatch.seg_apellido || ''}`.trim();
          this.new_prospecto.persona_id = exactMatch.id;
          this.new_prospecto.persona_name = name;

          const idprof = exactMatch.profesiones.length > 0 ? exactMatch.profesiones[0].id : null
          const profItem = this.profesiones.find((p) => String(p.id) === String(idprof));
          this.new_persona_data.profesiones = profItem ? profItem.id : null;

          const idprog = exactMatch.grados.length > 0 ? exactMatch.grados[0].nombre : null
          const gradItem = this.grados.find((p) => String(p.nombre) === String(idprog));
          this.new_persona_data.grados = gradItem ? gradItem.id : null;

          const idcity = exactMatch.ciudad ? exactMatch.ciudad.id : null;
          const cityItem = this.ciudades.find((p) => String(p.id) === String(idcity));
          this.new_persona_data.idciudad = cityItem ? cityItem.id : null;

          const idinst = exactMatch.idinstitucion ? exactMatch.idinstitucion : null;
          const instItem = this.instituciones.find((p) => String(p.id) === String(idinst));
          this.new_persona_data.idinstitucion = instItem ? instItem.id : null;

          const idnac = exactMatch.pais ? exactMatch.pais.id : null;
          const nacItem = this.nacionalidades.find((p) => String(p.id) === String(idnac));
          this.new_persona_data.idpais = nacItem ? nacItem.id : null;
          this.new_persona_data.fecha_nac = exactMatch.fecha_nac? exactMatch.fecha_nac.split('T')[0] : '';

        } else {
          this.personaEncontrada = null;
          const apellidos = (this.contacto.apellidos || '').trim().split(/\s+/);
          this.new_persona_data.num_doc = this.carnetBusqueda;
          this.new_persona_data.nombres = this.contacto.nombres || '';
          this.new_persona_data.pri_apellido = apellidos[0] || '';
          this.new_persona_data.seg_apellido = apellidos.slice(1).join(' ') || '';
          this.new_persona_data.email = this.contacto.correo || '';
          this.new_persona_data.telefono1 = this.getTelNormalizado(this.contacto.telefono || this.contacto.telefono1 || '');
          this.new_persona_data.sexo = null;
          
          const profItem = this.profesiones.find((p) => p.nombre.toLowerCase() === (this.contacto.profesion_name || '').toLowerCase());
          this.new_persona_data.profesiones = profItem ? profItem.id : null;
        }
      },
      setDatosPrograma() {
        const pid = this.filtroprograma;
        this.new_prospecto.programa_id = pid ? pid.id : null;
        this.new_prospecto.programa_name = pid ? pid.nombre_compuesto : null;
        this.new_prospecto.sede_id = this.sede.id;
        this.new_prospecto.sede_name = this.sede.nombre;
      },
      onDocumentoChange(file) {
        if (this.documentoPreview) {
          URL.revokeObjectURL(this.documentoPreview);
          this.documentoPreview = null;
        }
        if (!file) return;
        this.documentoEsImagen = file.type.startsWith('image/');
        this.documentoPreview = URL.createObjectURL(file);

        this.doc_64 = ''
        const reader = new FileReader();
        reader.onload = (e) => {
          this.doc_64 = e.target.result; 
        };
        reader.onerror = () => {
          this.loading = false;
          this.$root.$notify.show('Error al cargar el archivo', { color: 'red', x: 'right' });
        };
        reader.readAsDataURL(this.documentoIdentidad);
      },
      async subirDocumentoIdentidad(personaId) {
        if (!this.documentoIdentidad) return; 
        window.console.log('subirDocumentoIdentidad', personaId, this.doc_64);
        this.uploading_doc = true
        const res = await subirDocumentoContacto(this.new_prospecto.persona_id, this.doc_64)
        this.uploading_doc = false
        window.console.log('resss', res);
        if(res && res.error){
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }else if(res && res.persona_id){
          this.$root.$notify.show('documento guardado', { color: 'green', x: 'right' });
        }
        
      },
      async enviar() {
        if (!this.new_prospecto.persona_id) {
          this.$root.$notify.show('seleccione la persona por ci o nombre, si no existe debe registrarla', { color: 'red', x: 'right' });
          return;
        }
        if (!this.filtroprograma) {
          this.$root.$notify.show('seleccione el programa donde se va prospectar', { color: 'red', x: 'right' });
          return;
        }
        if (this.filtroprograma.fase == 0 || this.filtroprograma.fase > 2) {
          this.$root.$notify.show('Fase del programa no valido', { color: 'red', x: 'right' });
          return;
        }

        const pid = this.filtroprograma; 
        const preins = {
          asesor_id: parseInt(this.contacto.asesor_id),
          estudiante_id: this.personaEncontrada? this.personaEncontrada.id : null,
          programa_id: pid ? pid.id : null,
          registrado_por: this.$store.state.DATA_USER.id,
        }
        this.loading = true
        const re = await realizar_preinscripcion_from_prospecto(preins) 
        this.loading = false
        if(re && re.error){
          this.loading = false;
          this.$root.$notify.show(re.error, { color: 'red', x: 'right' });
          return
        }

        if(re && !re.enrollment_id){
          this.$root.$notify.show('??', { color: 'red', x: 'right' });
          return
        }

        if(re && re.enrollment_id){
          this.$root.$notify.show('registrado como prospecto, ingrese a la pestaña "Prospecto" y solicite la preinscripción.', { color: 'green', x: 'right', timeout: 8000 });
          this.cerrar();
        }else {
          this.$root.$notify.show('no se pudo convertir a proespecto', { color: '#980000', x: 'right' });
        } 
      },
      async actualizarPersona() {
        if (!this.documentoIdentidad) {
          this.$root.$notify.show('El documento de identidad es obligatorio', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.idpais) {
          this.$root.$notify.show('La nacionalidad es obligatoria', { color: 'red', x: 'right' });
          return;
        }

        window.console.log('this.similitud_nombres',this.similitud_nombres,this.min_similitud)
        window.console.log('this.personaEncontrada',this.personaEncontrada)
        const input = {
          id: this.personaEncontrada.id,
          num_doc: this.personaEncontrada.num_doc,
          nombres: this.similitud_nombres <= this.min_similitud? this.new_persona_data.nombres : this.personaEncontrada.nombres,
          pri_apellido: this.similitud_nombres <= this.min_similitud? this.new_persona_data.pri_apellido : this.personaEncontrada.pri_apellido,
          seg_apellido: this.similitud_nombres <= this.min_similitud? this.new_persona_data.seg_apellido : this.personaEncontrada.seg_apellido,
          sexo: this.personaEncontrada.sexo || "O",
          tipo: this.personaEncontrada.tipo || "P",
          diestro: true,
          email: this.new_persona_data.email,
          telefono1: this.new_persona_data.telefono1,
          // sexo: this.new_persona_data.sexo,
          profesiones: this.new_persona_data.profesiones ? [this.new_persona_data.profesiones] : [],
          grados: this.new_persona_data.grados ? [{ idgrado: this.new_persona_data.grados, titulo: 'sin titulo' }] : [],
          idciudad: this.new_persona_data.idciudad,
          domicilio: this.personaEncontrada.domicilio,
          est_civil: this.personaEncontrada.est_civil,
          iddepartamento: this.personaEncontrada.departamento?.id,
          idinstitucion: this.new_persona_data.idinstitucion,
          idpais: this.new_persona_data.idpais,
        };

        if(!input.iddepartamento) delete input.iddepartamento;

        this.isUpdatingPersona = true;
        const sql = gql`mutation{ updatePersona(input:${window.stringifyObject(input)}){ ok, errors{message} } }`;
        try {
          const { data } = await this.$apollo.mutate({ mutation: sql });
          const res = data && data.updatePersona ? data.updatePersona : null;
          if (res && res.ok) {
            await this.subirDocumentoIdentidad(this.personaEncontrada.id);
            this.$root.$notify.show('Persona actualizada correctamente', { color: 'green', x: 'right' });
            this.searchDone = false;
            this.buscarPersona();
          } else if (res && res.errors) {
            this.$root.$notify.show(JSON.stringify(res.errors), { color: 'red', x: 'right' });
          } else {
            this.$root.$notify.show('No se pudo actualizar la persona', { color: 'red', x: 'right' });
          }
        } catch (e) {
          this.$root.$notify.show('Error al actualizar la persona', { color: 'red', x: 'right' });
        } finally {
          this.isUpdatingPersona = false;
        }
      },
      crearNuevaPersona() {
        if (this.isCreatingPersona) return;
        if (!this.new_persona_data.num_doc || !this.new_persona_data.nombres) {
          this.$root.$notify.show('complete el documento y nombres', { color: 'red', x: 'right' });
          return;
        }
        if (this.new_persona_data.num_doc.length < 5) {
          this.$root.$notify.show('el número de documento debe tener al menos 5 caracteres', { color: 'red', x: 'right' });
          return;
        }
        if (/[a-zA-ZáéíóúÁÉÍÓÚñÑ]{4,}/.test(this.new_persona_data.num_doc)) {
          this.$root.$notify.show('el número de documento no puede tener más de 3 letras seguidas', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.pri_apellido) {
          this.$root.$notify.show('complete el primer apellido', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.sexo) {
          this.$root.$notify.show('seleccione el sexo', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.profesiones) {
          this.$root.$notify.show('seleccione la profesión', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.grados) {
          this.$root.$notify.show('seleccione un grado academico', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.email) {
          this.$root.$notify.show('complete el correo', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.idciudad) {
          this.$root.$notify.show('seleccione la ciudad', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.idinstitucion) {
          this.$root.$notify.show('seleccione la institucion', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.idpais) {
          this.$root.$notify.show('seleccione la nacionalidad', { color: 'red', x: 'right' });
          return;
        }
        if (!this.new_persona_data.fecha_nac) {
          this.$root.$notify.show('ingrese la fecha de nacimiento', { color: 'red', x: 'right' });
          return;
        }
        if (!this.documentoIdentidad) {
          this.$root.$notify.show('suba el documento de identidad', { color: 'red', x: 'right' });
          return;
        }
        const input = {
          num_doc: this.new_persona_data.num_doc,
          nombres: this.new_persona_data.nombres,
          pri_apellido: this.new_persona_data.pri_apellido,
          seg_apellido: this.new_persona_data.seg_apellido,
          email: this.new_persona_data.email,
          sexo: this.new_persona_data.sexo,
          tipo: this.new_persona_data.tipo || 'P',
          diestro: this.new_persona_data.diestro === false ? false : true,
          telefono1: this.new_persona_data.telefono1,
          profesiones: this.new_persona_data.profesiones ? [this.new_persona_data.profesiones] : [],
          grados: this.new_persona_data.grados ? [{idgrado:this.new_persona_data.grados, titulo:'sin titulo'}] : [],
          idciudad: this.new_persona_data.idciudad,
          idinstitucion: this.new_persona_data.idinstitucion,
          idpais: this.new_persona_data.idpais,
          fecha_nac: this.new_persona_data.fecha_nac || null,
        };
        const sql = gql`mutation{ createPersona(input:${window.stringifyObject(input)}){ok,persona{id,num_doc,nombres,pri_apellido,seg_apellido},errors{message}} }`;
        this.isCreatingPersona = true;
        this.$apollo
          .mutate({ mutation: sql })
          .then(async ({ data }) => {
            const res = data && data.createPersona ? data.createPersona : null;
            if (res && res.ok && res.persona) {
              const persona = res.persona;
              const name = `${persona.nombres} ${persona.pri_apellido} ${persona.seg_apellido || ''}`.trim();
              this.new_prospecto.persona_id = persona.id;
              this.new_prospecto.persona_name = name;
              await this.subirDocumentoIdentidad(persona.id);
              this.$root.$notify.show('persona registrada', { color: 'green', x: 'right' });
              this.searchDone = false;
              this.buscarPersona();
              
            } else if (res && res.errors) {
              this.$root.$notify.show(JSON.stringify(res.errors), { color: 'red', x: 'right' });
            } else {
              this.$root.$notify.show('no se pudo registrar la persona', { color: 'red', x: 'right' });
            }
          })
          .catch((error) => {
            let text = '';
            error.graphQLErrors.forEach((x) => {
              x.message.message.forEach((m) => {
                text += m.error[0] + ' ';
              });
            });
            this.$root.$notify.show(text, { color: 'red', x: 'right' });
          })
          .finally(() => {
            this.isCreatingPersona = false;
          });
      },
      jaroWinkler(s1, s2) {
        if (s1 === s2) return 1.0;
        const l1 = s1.length, l2 = s2.length;
        const matchDist = Math.max(Math.floor(Math.max(l1, l2) / 2) - 1, 0);
        const m1 = new Array(l1).fill(false);
        const m2 = new Array(l2).fill(false);
        let matches = 0, transpositions = 0;
        for (let i = 0; i < l1; i++) {
          const start = Math.max(0, i - matchDist);
          const end = Math.min(i + matchDist + 1, l2);
          for (let j = start; j < end; j++) {
            if (m2[j] || s1[i] !== s2[j]) continue;
            m1[i] = m2[j] = true;
            matches++;
            break;
          }
        }
        if (!matches) return 0;
        let k = 0;
        for (let i = 0; i < l1; i++) {
          if (!m1[i]) continue;
          while (!m2[k]) k++;
          if (s1[i] !== s2[k]) transpositions++;
          k++;
        }
        const jaro = (matches / l1 + matches / l2 + (matches - transpositions / 2) / matches) / 3;
        let prefix = 0;
        for (let i = 0; i < Math.min(4, Math.min(l1, l2)); i++) {
          if (s1[i] === s2[i]) prefix++;
          else break;
        }
        return jaro + prefix * 0.1 * (1 - jaro);
      },
      async loadProfesiones() {
        if (this.profesiones.length) return;
        this.isLoadingProfesiones = true;
        const sql = gql`query{ getProfesiones(estado:true){ id, nombre } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          this.profesiones = r && r.getProfesiones ? r.getProfesiones : [];
        } catch (e) {
          window.console.error(e);
          this.profesiones = [];
        } finally {
          this.isLoadingProfesiones = false;
        }
      },
      async loadInstituciones() {
        if (this.instituciones.length) return;
        this.isLoadinginstituciones = true;
        const sql = gql`query{ getInstituciones{ id, nombre, convenio } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          this.instituciones = r && r.getInstituciones ? r.getInstituciones : [];
        } catch (e) {
          window.console.error(e);
          this.instituciones = [];
        } finally {
          this.isLoadinginstituciones = false;
        }
      },
      async loadNacionalidades() {
        if (this.nacionalidades.length) return;
        this.isLoadingNacionalidades = true;
        const sql = gql`query{ getPaises { id, nombre } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          this.nacionalidades = r && r.getPaises ? r.getPaises : [];
        } catch (e) {
          window.console.error(e);
          this.nacionalidades = [];
        } finally {
          this.isLoadingNacionalidades = false;
        }
      },
      async loadCiudades() {
        if (this.ciudades.length) return;
        this.isLoadingCiudades = true;
        const sql = gql`query{ getCiudades { id, nombre, departamento{ nombre } } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          const datos = r && r.getCiudades ? r.getCiudades : [];
          this.ciudades = datos.map((e) => {
            const dep = e.departamento && e.departamento.nombre ? ` (${e.departamento.nombre})` : '';
            return { id: e.id, nombre: `${e.nombre}${dep}` };
          });
        } catch (e) {
          window.console.error(e);
          this.ciudades = [];
        } finally {
          this.isLoadingCiudades = false;
        }
      },
      async loadGrados() {
        if (this.grados.length) return;
        this.isLoadinggrados = true;
        const sql = gql`query{ getGrados { id, nombre, abreviatura } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          this.grados = r && r.getGrados ? r.getGrados : [];
        } catch (e) {
          window.console.error(e);
          this.grados = [];
        } finally {
          this.isLoadinggrados = false;
        }
      },
      opencursados(){
        this.$refs.refverCursados.openmodal(this.personaEncontrada)
      },
      resetNewPersonaData() {
        this.new_persona_data = {
          num_doc: '',
          nombres: '',
          pri_apellido: '',
          seg_apellido: '',
          email: '',
          sexo: '',
          tipo: 'P',
          diestro: true,
          telefono1: '',
          profesiones: null,
          idciudad: null,
          idpais: null,
          fecha_nac: '',
        };
      },
    },
    mounted() {},
  };
</script>

<style scoped>
.np-card {
  border-radius: 14px;
  overflow: hidden;
}
.np-hero {
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
.doc-preview-wrap {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  max-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}
.doc-preview-img {
  max-width: 100%;
  max-height: 320px;
  object-fit: contain;
}
.doc-preview-pdf {
  width: 100%;
  height: 320px;
  border: none;
}

/* Sexo toggle */
.sexo-field-wrap {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 6px;
  margin-bottom: 8px;
}
.sexo-field-label {
  position: absolute;
  top: -8px;
  left: 8px;
  background: #f5f7fa;
  padding: 0 3px;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1;
}
.sexo-toggle {
  width: 100%;
}
.sexo-toggle .v-btn {
  flex: 1;
  font-size: 12px !important;
  height: 24px !important;
}

/* Sección persona */
.persona-section {
  margin-bottom: 4px;
}
.np-alert {
  font-size: 12px !important;
  padding: 6px 10px !important;
}
.persona-form {
  background: #f5f7fa;
  border: 1px solid #dde3ed;
  border-left: 3px solid #90a4ae;
  border-radius: 6px;
  padding: 10px 12px 2px;
}
.persona-form >>> .v-label {
  font-size: 11.5px !important;
}
.persona-form >>> .v-input input,
.persona-form >>> .v-select__selection {
  font-size: 12px !important;
}
.persona-form >>> .v-input__slot {
  min-height: 32px !important;
}
.persona-form >>> .v-input__prepend-inner {
  margin-top: 4px !important;
}
.persona-form >>> .v-input__prepend-inner .v-icon {
  font-size: 16px !important;
}

/* Modo edición (persona no verificada) */
.persona-form--editable {
  border-left-color: #7986cb;
}

/* Campos editables: fondo blanco con borde azul suave */
.persona-form--editable >>> .v-input:not(.v-input--is-readonly) .v-input__slot {
  background: #ffffff !important;
}
.persona-form--editable >>> .v-input:not(.v-input--is-readonly) fieldset {
  border-color: #7986cb !important;
}

/* Campos readonly: fondo gris muy suave + atenuados */
.persona-form--editable >>> .v-input--is-readonly .v-input__slot {
  background: #f0f0f0 !important;
}
.persona-form--editable >>> .v-input--is-readonly fieldset {
  border-color: #d0d0d0 !important;
}
.persona-form--editable >>> .v-input--is-readonly input,
.persona-form--editable >>> .v-input--is-readonly .v-select__selection,
.persona-form--editable >>> .v-input--is-readonly .v-label {
  color: #aaaaaa !important;
}

/* Sexo toggle: botones deshabilitados también se notan */
.persona-form--editable .sexo-field-wrap {
  background: #f0f0f0;
  border-color: #d0d0d0;
}
.persona-form--editable .sexo-field-wrap .sexo-field-label {
  color: #aaaaaa;
}

</style>
